const OPTION_FILTER_IDS: Record<string, string> = {
  insfull: 'comprehensive_cover_without_deductible',
  fib_ab: 'car_class_small',
  fib_ad: 'car_class_compact',
  fib_al: 'car_class_upper',
  fib_ae: 'car_type_wagon_estate',
  fib_af: 'car_class_middle',
  fib_ed: 'mileage_unlimited',
  fib_ec: 'additional_driver_included',
  fib_eb: 'winter_tires',
  fib_ee: 'fuel_policy_good',
};

export const getOptionsParam = (checkedOptions: string[]) =>
  new URLSearchParams(
    checkedOptions.map(option => ['filter', OPTION_FILTER_IDS[option]]),
  ).toString();

export const isTransporterSearch = (prefilterQuery?: string) =>
  new URLSearchParams(prefilterQuery)
    .getAll('filter')
    .includes('car_class_transporter');
